import { render, staticRenderFns } from "./classiccustomerLogo.vue?vue&type=template&id=edb374ac&scoped=true&"
import script from "./classiccustomerLogo.vue?vue&type=script&lang=js&"
export * from "./classiccustomerLogo.vue?vue&type=script&lang=js&"
import style0 from "./classiccustomerLogo.vue?vue&type=style&index=0&id=edb374ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb374ac",
  null
  
)

export default component.exports